import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { ShoppingBag, Truck, Package, DownloadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Product() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [qty, setQty] = useState(1);
  const { add } = useCart();
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/products/${id}`).then(({ data }) => setP(data)).catch(() => setP(null));
  }, [id]);

  if (!p) return <div className="max-w-7xl mx-auto px-6 py-20 font-mono">Loading…</div>;

  const addToCart = () => { add(p, qty); toast.success("Added to cart"); };
  const buyNow = () => { add(p, qty); nav("/checkout"); };

  const fulfillIcon = p.fulfillment === "digital" ? <DownloadSimple size={18}/> :
    p.fulfillment === "mail" ? <Package size={18}/> : <Truck size={18}/>;

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-10 py-12" data-testid="product-page">
      <Link to="/" className="overline opacity-60 hover:text-signal">← back to shop</Link>
      <div className="grid lg:grid-cols-12 gap-12 mt-6">
        <div className="lg:col-span-7 border border-white/10 bg-[#111111]">
          <img src={p.image_url} alt={p.name} className="w-full max-h-[70vh] object-cover" data-testid="product-image" />
        </div>
        <div className="lg:col-span-5 flex flex-col">
          <p className="overline opacity-50 mb-2">[{(p.category || "general").toUpperCase()}]</p>
          <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter leading-none mb-4" data-testid="product-name">
            {p.name}
          </h1>
          <p className="font-mono text-2xl mb-6" data-testid="product-price">${p.price.toFixed(2)}</p>
          <p className="font-sans text-base text-neutral-400 leading-relaxed mb-8" data-testid="product-description">
            {p.description}
          </p>

          <div className="flex items-center gap-2 text-sm font-mono mb-8 border border-white/10 p-4 bg-[#111111]">
            {fulfillIcon}
            <span className="opacity-60">Fulfillment:</span>
            <span className="uppercase tracking-widest">{p.fulfillment}</span>
          </div>

          <div className="flex items-center gap-4 mb-6">
            <label className="overline opacity-60">Qty</label>
            <div className="flex items-center border border-white/20">
              <button onClick={() => setQty(Math.max(1, qty - 1))}
                className="px-3 py-2 hover:bg-obsidian hover:text-bone font-mono"
                data-testid="qty-minus">−</button>
              <input type="number" value={qty} onChange={(e) => setQty(Math.max(1, parseInt(e.target.value || "1")))}
                className="w-14 text-center font-mono bg-transparent py-2 outline-none"
                data-testid="qty-input" />
              <button onClick={() => setQty(qty + 1)}
                className="px-3 py-2 hover:bg-obsidian hover:text-bone font-mono"
                data-testid="qty-plus">+</button>
            </div>
          </div>

          <div className="flex flex-wrap gap-3">
            <button onClick={buyNow} className="btn-signal" data-testid="buy-now-btn">
              Buy now →
            </button>
            <button onClick={addToCart} className="btn-outline-dark" data-testid="add-cart-btn">
              <ShoppingBag size={16}/> Add to cart
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}
